import { render } from "./AddStoreModal.vue?vue&type=template&id=5122d401&scoped=true"
import script from "./AddStoreModal.vue?vue&type=script&lang=js"
export * from "./AddStoreModal.vue?vue&type=script&lang=js"

import "./AddStoreModal.vue?vue&type=style&index=0&id=5122d401&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5122d401"]])

export default __exports__